export default __webpack_public_path__ + "static/media/clube-img1.ccc4b314.jpg";